import React from 'react';
import T from 'prop-types';

import { CheckboxGroupInput, SimpleForm } from 'react-admin';
import { useForm, useFormState } from 'react-final-form';

import DialogTitle from '@material-ui/core/DialogTitle';
import Drawer from '@material-ui/core/Drawer';

import { SelectAllCheckbox } from '../inputs/SelectAllCheckbox';

const SOURCE = 'value';

const SelectAllExportColumns = ({ choices, optionValue, onChange }) => {
  const form = useForm();
  const { values } = useFormState({ subscription: { values: true } });

  const choiceIds = choices.map((choice) => choice[optionValue]);
  const selected = values[SOURCE] || [];
  const selectedCount = choiceIds.filter((id) => selected.includes(id)).length;

  const handleToggle = (shouldSelectAll) => {
    const newValue = shouldSelectAll ? choiceIds : [];
    form.change(SOURCE, newValue);
    onChange(newValue);
  };

  return (
    <SelectAllCheckbox
      selectedCount={selectedCount}
      totalCount={choiceIds.length}
      onToggle={handleToggle}
    />
  );
};

SelectAllExportColumns.propTypes = {
  choices: T.arrayOf(T.object).isRequired,
  optionValue: T.string.isRequired,
  onChange: T.func.isRequired,
};

export const CheckboxGroupDrawer = ({ value, onClose, onChange, title, choices = [], optionValue = 'id', ...rest }) => {
  const [ currValue, setCurrValue ] = React.useState(value);

  const handleClose = (e) => {
    onClose(currValue);
  };
  const handleChange = (val) => {
    if (onChange) onChange(val);
    setCurrValue(val);
  };

  return (
    <Drawer maxWidth="xs" anchor="left" onClose={handleClose} open>
      {title && <DialogTitle id="ra-columns-dialog-title">{title}</DialogTitle>}
      <SimpleForm initialValues={{value}} toolbar={null} sx={{ maxWidth: 600 }}>
        <SelectAllExportColumns choices={choices} optionValue={optionValue} onChange={handleChange}/>
        <CheckboxGroupInput label="" source={SOURCE} row={false} onChange={handleChange} choices={choices} optionValue={optionValue} {...rest}/>
      </SimpleForm>
    </Drawer>
  );
}

CheckboxGroupDrawer.propTypes = {
  value: T.array,
  onClose: T.func.isRequired,
  onChange: T.func,
  title: T.string,
  choices: T.arrayOf(T.object),
  optionValue: T.string,
};
